<template>
  <div class="content content-scroll">
    <div class="page-inner">
      <div class="d-flex align-items-left align-items-md-center flex-column flex-md-row pt-2 pb-2">
        <div>
          <span class="page-main-title pb-0 bold-500 text-35">{{ $t('analytics') }}</span>
          <h5 class="op-7 mb-3">{{ $t('analytics_slogan') }}</h5>
          <div class="alert alert-info alert-dismissible mt-3" v-if="showAnalyticsExplanation">
            <div>
              {{ $t('analytics_explanation') }}
            </div>
            <div class="text-right mt-3">
              <button type="button" class="btn btn-default" data-dismiss="alert" aria-label="Close">{{ $t('understood') }}</button>
            </div>
          </div>
        </div>
      </div>

      <UpgradeBanner v-if="!user.subscription"></UpgradeBanner>

      <div class="card" v-if="showAIInsights">
        <div class="card-body pos-relative">
          <p class="badge badge-info badge-date" v-if="aiInsights && aiInsights.response">
            {{ $t('today_insights') }} {{ moment().format('LL') }}
          </p>
          <div class="row">
            <div class="col-md-2 bot-container">
              <img src="/static/img/indiebot.png" class="animated pulse indiebot" alt="">
            </div>
            <div class="col-md-10">
              <div class="talk-bubble" :class="{ 'tri-right left-top': !isMobile() }">
                <div class="talktext">
                  <p v-if="!loadingAI && !showBotAnswer">
                    {{ $t('indiebot_today_insights') }}<br/>
                    <button type="button" @click="toggleBotAnswer()" class="btn btn-primary mt-2">{{ $t('show_insights') }}</button>
                  </p>
                  <p v-if="loadingAI">
                    <i class="fa fa-spinner fa-spin mr-2"></i> {{ $t('analyzing_data') }}
                  </p>
                  <p v-if="aiInsights" v-html="aiInsights.response" v-show="showBotAnswer">
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-show="artistsLoaded && !artists.length">
        <div class="card mt-2">
          <div class="card-body text-center">
            {{ $t('no_data_yet') }}
          </div>
        </div>
      </div>

      <div v-show="artistsLoaded && artists.length">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <!-- <div class="col-md-4">
                <div class="form-group">
                  <label class="mr-2">{{ $t('select_metric') }}:</label>
                  <div>
                    <button type="button" class="btn btn-primary dropdown-toggle btn-sm w-100 analytics-type" data-toggle="dropdown">
                      {{ analyticsType }}
                    </button>
                    <div class="dropdown-menu">
                      <a class="dropdown-item" href="JavaScript:Void(0);" @click="setAnalyticType('General')">General</a>
                      <a class="dropdown-item disabled" href="JavaScript:Void(0);">Spotify Insights <span class="strong ml-4 float-right">(Coming soon) PRO <i class="fas fa-lock"></i></span></a>
                      <a class="dropdown-item disabled" href="JavaScript:Void(0);">Apple Insights <span class="strong ml-4 float-right">(Coming soon) PRO <i class="fas fa-lock"></i></span></a>
                      <a class="dropdown-item disabled" href="JavaScript:Void(0);">Demographics <span class="strong ml-4 float-right">(Coming soon) PRO <i class="fas fa-lock"></i></span></a>
                    </div>
                  </div>
                </div>
              </div> -->
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t('artist') }}</label>
                  <Select2 v-model="artistId" :options="artists"></Select2>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t('time_range') }}</label>
                  <Select2 :options="streamRangeOptions" v-model="timeRange"></Select2>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-show="analyticsType === 'General'">
          <div class="row">
            <!-- <div class="col-md-12">
              <div v-if="!user.subscription" class="text-center mb-3 mt-3">
                <ins class="adsbygoogle"
                    style="display:block"
                    data-ad-client="ca-pub-8326584585992829"
                    data-ad-slot="9491304951"
                    data-ad-format="auto"
                    data-full-width-responsive="true"></ins>
              </div>
            </div> -->

            <!-- <div v-if="!user.subscription" class="text-center col-12 mb-3">
              <ins class="adsbygoogle"
                  style="display:block"
                  data-ad-client="ca-pub-8326584585992829"
                  data-ad-slot="9491304951"
                  data-ad-format="auto"
                  data-full-width-responsive="true"></ins>
            </div> -->

            <div class="col-md-12">
              <div class="card">
                <div class="card-header">
                  <div class="card-title">
                    <span>{{ $t('streams_chart') }}</span>
                  </div>
                </div>
                <div class="card-body">
                  <div class="mb-4">
                    <div class="row">
                      <div class="col-md-3 col-lg-3" v-if="!user.subscription">
                        <div class="form-group">
                          <label>{{ $t('group_by') }}</label>
                          <div>
                            <div class="btn-group" role="group">
                              <button type="button" class="btn btn-primary active">
                                <span class="d-none d-md-inline">
                                  {{ $t('all_streams') }}
                                </span>
                                <span class="d-inline d-md-none">
                                  {{ $t('all') }}
                                </span>
                              </button>
                              <router-link to="/upgrade?from=analytics" type="button" class="btn btn-primary">{{ $t('by_platform') }}</router-link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="p-5 text-center" v-if="loadingStreams">
                    <i class="fas fa-spinner fa-2x fa-spin text-muted"></i>
                  </div>
                  <div v-if="!loadingStreams && !streamsData.data">
                    <div class="mb-2 text-small">
                      <a href="https://indiefysupport.zendesk.com/hc/en-us/articles/360047284693">{{ $t('why_no_data_yet') }}</a>
                    </div>
                    <div style="height: 400px" class="bg-light d-flex align-items-center justify-content-center">
                      <div class="text-center">
                        <h1 class="strong text-dark text-uppercase">{{ $t('graph_no_data_yet') }}</h1>
                        <div class="avatar avatar-sm">
                          <img src="/static/img/favicon.png" alt="indiefy-logo" class="avatar-img rounded-circle">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="!loadingStreams && streamsData.data">
                    <div class="text-right">
                      <span class="mr-2">{{ $t('graph') }}:</span>
                      <button type="button" class="btn btn-icon btn-sm" :class="{'btn-primary': streamGraphType === 'bar', 'btn-link': streamGraphType !== 'bar'}" @click="setStreamGraphType('bar')">
                        <i class="fas fa-chart-bar"></i>
                      </button>
                      <button type="button" class="btn btn-icon btn-sm" :class="{'btn-primary': streamGraphType === 'line', 'btn-link': streamGraphType !== 'line'}" @click="setStreamGraphType('line')">
                        <i class="fas fa-chart-line"></i>
                      </button>
                    </div>
                    <div class="chart-container">
                      <canvas ref="streamsCanvas" style="height: 100px;"></canvas>
                    </div>
                    <div id="streamsChartLegend"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-header">
              <div class="card-title">
                <span>{{ $t('songs_chart') }} <span class="badge badge-primary ml-1">PRO</span></span>
              </div>
            </div>
            <div class="card-body pos-relative p-0">
              <UpgradeOverlay v-if="!isPro" :title="$t('streams_by_track')" :text="$t('streams_by_track_text')"></UpgradeOverlay>
              <div class="p-5 text-center" v-if="loadingSongs">
                <i class="fas fa-spinner fa-2x fa-spin text-muted"></i>
              </div>
              <div v-if="!loadingSongs && !songsData.length">
                <div class="mb-2 text-small">
                  <a href="https://indiefysupport.zendesk.com/hc/en-us/articles/360047284693">{{ $t('why_no_data_yet') }}</a>
                </div>
                <div style="height: 400px" class="bg-light d-flex align-items-center justify-content-center">
                  <div class="text-center">
                    <h1 class="strong text-dark text-uppercase">{{ $t('graph_no_data_yet') }}</h1>
                    <div class="avatar avatar-sm">
                      <img src="/static/img/favicon.png" alt="indiefy-logo" class="avatar-img rounded-circle">
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="!loadingSongs && songsData.length" class="table-responsive">
                <table class="table table-striped mb-0">
                  <thead>
                    <tr>
                      <th width="5%">#</th>
                      <th>{{ $t('song') }}</th>
                      <th>{{ $t('streams') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(track, index) in songsData" v-bind:key="`track_${index}`">
                      <td>{{ index + 1 }}</td>
                      <td>{{ track.name }}</td>
                      <td>{{ track.totals.count }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- <div v-if="!user.subscription" class="text-center col-12 mb-3">
            <ins class="adsbygoogle"
                style="display:block"
                data-ad-client="ca-pub-8326584585992829"
                data-ad-slot="9491304951"
                data-ad-format="auto"
                data-full-width-responsive="true"></ins>
          </div> -->

          <div class="row d-sm-block">
            <div class="col-md-12">
              <div class="card">
                <div class="card-header">
                  <div class="card-head-row card-tools-still-right">
                    <h4 class="card-title">
                      {{ $t('territory_analytics') }} <span class="badge badge-primary ml-1">PRO</span>
                    </h4>
                  </div>
                </div>
                <div class="card-body pos-relative p-0">
                  <UpgradeOverlay v-if="!isPro" :title="$t('streams_by_territory')" :text="$t('streams_by_territory_text')"></UpgradeOverlay>
                  <div class="p-5 text-center" v-if="loadingCountries">
                    <i class="fas fa-spinner fa-2x fa-spin text-muted"></i>
                  </div>
                  <div class="text-center" v-if="!loadingCountries">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="table-responsive table-hover table-sales">
                          <table class="table mb-0 streams-table">
                            <tbody>
                              <tr v-if="!loadingCountries && !countryData.length" class="my-5">
                                <td class="strong">
                                  {{ $t('no_data_yet') }}<br/><br/>
                                </td>
                              </tr>
                              <tr v-for="(country, index) in countryData" v-bind:key="`country_${index}`">
                                <td>
                                  <div class="flag">
                                    <img width="16" :src="`/static/img/countries/${country.id.toUpperCase()}.png`" :alt="country.name" onerror="this.src = '/static/img/img-placeholder.jpg'">
                                  </div>
                                </td>
                                <td>{{ country.name }}</td>
                                <td class="text-right">
                                  {{ country.totals.count }}
                                </td>
                                <td class="text-right" :class="{ 'text-success': country.totals.percentage > 0, 'text-danger': country.totals.percentage < 0 }">
                                  {{ country.totals.percentage ? country.totals.percentage.toFixed(2) : 0 }}%
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="mapcontainer" v-if="!loadingCountries && countryData.length">
                          <div ref="mapChart" style="height: 300px;" class="v-map"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="!isPro && !loadingCountries" class="p-4 mt-4 mb-4">-</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <PlaylistsCard v-if="pageLoaded && artists.length && currentArtist && currentArtist.f_id && artistId" :artistId="artistId" :fugaId="currentArtist.f_id" :artists="artists"></PlaylistsCard>
            </div>
          </div>
        </div>
        <div v-show="analyticsType === 'Spotify Insights'">
          <div class="row">
            <div class="col-md-6">
              <div class="card">
                <div class="card-body p-0">
                  <div class="p-4 bg-light">
                    <h1 class="strong">Spotify Insights</h1>
                    <h4>Play duration</h4>
                    <p>Play duration offers you data of what releases are working best and what releases are not being complety streamed. Having tracks streamed less than 30s could mean user is not being hooked or skips to certain parts of the track.</p>
                  </div>
                  <div>
                    <canvas ref="playDurationCanvas" width="800" height="450"></canvas>
                  </div>
                  <div ref="playDurationLabels" id="playDurationLabels"></div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="card">
                <div class="card-body p-0">
                  <div class="p-4 bg-light">
                    <h1 class="strong">Spotify Insights</h1>
                    <h4>Play duration</h4>
                    <p>Play duration offers you data of what releases are working best and what releases are not being complety streamed. Having tracks streamed less than 30s could mean user is not being hooked or skips to certain parts of the track.</p>
                  </div>
                  <div>
                    <canvas ref="playDurationDetailCanvas" width="800" height="450"></canvas>
                  </div>
                  <div ref="playDurationDetailLabels"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-6 col-md-6">
              <div class="card">
                <div class="card-body p-0">
                  <div class="bg-light p-4 pb-5">
                    <h4>Gender</h4>
                    <p>Know a bit more about your audience, use the information to your advantage for your social campaigns.</p>
                  </div>
                  <div>
                    <canvas ref="genderCanvas" width="800" height="450"></canvas>
                  </div>
                  <div ref="genderLabels"></div>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-md-6">
              <div class="card">
                <div class="card-body p-0">
                  <div class="bg-light p-4">
                    <h4>Device</h4>
                    <p>Know from where is your audience streaming your content the most, you can use this to create a new content based on the most used device.</p>
                  </div>
                  <div>
                    <canvas ref="deviceCanvas" width="800" height="450"></canvas>
                  </div>
                  <div ref="deviceLabels"></div>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-md-6">
              <div class="card">
                <div class="card-body p-0">
                  <div class="bg-light p-4">
                    <h4>Age Group</h4>
                    <p>Know from where is your audience streaming your content the most, you can use this to create a new content based on the most used device.</p>
                  </div>
                  <div>
                    <canvas ref="ageCanvas" width="800" height="450"></canvas>
                  </div>
                  <div ref="ageLabels"></div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!-- modals -->
    <div ref="topTrackModal" class="modal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <div class="modal-body p-0">
            <div v-if="topTrackData">
              <img :src="getCover(topTrackData)" alt="cover" class="w-100">
              <div class="d-flex justify-content-center mt-4">
                <div class="mt--3">
                  <span class="fw-bold mb-0 mr-4 mt-1 text-50">{{ topTrackData.number }}</span>
                </div>
                <div>
                  <h3 class="fw-extrabold mb-0">{{ topTrackData.name }}</h3>
                  <div class="mt--2">
                    <small class="text-muted">{{ topTrackData.artist }}</small>
                  </div>
                </div>
              </div>
            </div>
            <div class="separator-dashed"></div>
            <div class="row mt-4" v-if="topTrackData  && topTrackData.streams">
              <div class="col-4 col-sm-3 col-md-3 text-center">
                <p class="my-0"><i class="far fa-play-circle"></i></p>
                <span class="text-success h5" v-if="topTrackData.streams.weekly.percentage > 0">
                  <i class="fas fa-arrow-up"></i>
                </span>
                <span class="text-danger h5" v-if="topTrackData.streams.weekly.percentage < 0">
                  <i class="fas fa-arrow-down"></i>
                </span>
                <span class="strong h3">{{ topTrackData.streams.weekly.count }}</span>
                <p class="text-small">{{ $t('weekly') }}</p>
              </div>
              <div class="col-4 col-sm-3 col-md-3 text-center">
                <p class="my-0"><i class="far fa-play-circle"></i></p>
                <span class="text-success h5" v-if="topTrackData.streams.monthly.percentage > 0">
                  <i class="fas fa-arrow-up"></i>
                </span>
                <span class="text-danger h5" v-if="topTrackData.streams.monthly.percentage < 0">
                  <i class="fas fa-arrow-down"></i>
                </span>
                <span class="strong h3">{{ topTrackData.streams.monthly.count }}</span>
                <p class="text-small">{{ $t('monthly') }}</p>
              </div>
              <div class="col-4 col-sm-3 col-md-3 text-center">
                <p class="my-0"><i class="far fa-play-circle"></i></p>
                <span class="text-success h5" v-if="topTrackData.streams.yearly.percentage > 0">
                  <i class="fas fa-arrow-up"></i>
                </span>
                <span class="text-danger h5" v-if="topTrackData.streams.yearly.percentage < 0">
                  <i class="fas fa-arrow-down"></i>
                </span>
                <span class="strong h3">{{ topTrackData.streams.yearly.count }}</span>
                <p class="text-small">{{ $t('yearly') }}</p>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-success" data-dismiss="modal">{{ $t('close') }}</button>
          </div>
        </div>
      </div>
    </div>
    <UpgradeModal></UpgradeModal>
  </div>
</template>
<script>
import _ from 'underscore'
import moment from 'moment'
import Select2 from './utils/Select2'
import Analytics from '../services/analytics'
import Artists from '../services/artists'
import Distributions from '../services/distributions'
import PlaylistsCard from './PlaylistsCard.vue'
import UpgradeOverlay from './UpgradeOverlay'
import UpgradeModal from './utils/UpgradeModal'
import AI from '../services/ai'
import UpgradeBanner from '../components/UpgradeBanner'

export default {
  name: 'Analytics',
  data: function () {
    return {
      pageLoaded: false,
      moment: moment,
      showAnalyticsExplanation: false,
      artistsLoaded: false,
      showBotAnswer: false,
      user: {},
      showAIInsights: false,
      aiInsights: null,
      loadingAI: false,
      isPro: false,
      streamsData: {},
      songsData: [],
      topTracks: [],
      countryFrom: '',
      countryTo: '',
      artists: [],
      loadingCountries: true,
      loadingStreams: true,
      loadingSongs: true,
      currentArtist: null,
      artistId: '',
      countryData: [],
      songs: [],
      analyticsType: 'General',
      streamGraphType: 'line',
      streamChart: null,
      selectedGauge: 'Weekly',
      topTrackData: null,
      streamRange: ['weekly', 'monthly', 'all'],
      currentData: [],
      streamRangeOptions: [
        {
          id: 'Weekly',
          text: this.$t('weekly')
        }, {
          id: 'Monthly',
          text: this.$t('monthly')
        }, {
          id: 'Yearly',
          text: this.$t('yearly') + ' (PRO)'
        }
      ],
      timeRange: 'Weekly',
      device: 'desktop',
      loadingData: true
    }
  },
  methods: {
    isMobile () {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    toggleBotAnswer: function () {
      if (!this.user.subscription || (this.user.subscription && this.user.subscription.plan_name === 'indiefy_lite')) {
        return this.$router.push('/upgrade?from=ai-analytics')
      }

      this.showBotAnswer = !this.showBotAnswer

      if (this.showBotAnswer && !this.aiInsights) {
        this.getBotInsights()
      }
    },
    getBotInsights: function () {
      this.loadingAI = true

      AI.getArtistInsights(this.currentArtist.id).then(response => {
        this.aiInsights = response.data
        this.loadingAI = false

        if (!this.aiInsights._id) {
          this.showBotAnswer = true
        }
      }).catch(response => {
        console.log('Error when getting AI data', response.data)
      })
    },
    getCover: function (top) {
      if (this.songs.length) {
        let song = _.find(this.songs, song => song.title.toLowerCase() === top.name.toLowerCase())

        if (song) {
          return song.cover
        } else {
          return top.image
        }
      } else {
        return top.image
      }
    },
    getArtistDistributions: async function () {
      await Distributions.getAll({ artist: this.artistId }).then(response => {
        let songs = []

        _.each(response.data, distro => {
          _.each(distro.songs, song => {
            songs.push({
              title: song.title,
              cover: distro.cover_image_small || distro.cover_image,
              _id: distro._id
            })
          })
        })

        this.songs = songs
      })
    },
    sumStreams: function (streams) {
      _.each(streams.data, (track, index) => {
        streams.total += track.totals.count
      })
    },
    setArtistImage: function (data) {
      _.each(data, item => {
        let artist = _.find(this.artists, artist => artist.text === item.artist)

        if (artist) {
          item.image = artist.image
        }
      })
    },
    renderMapChart: function () {
      let data = {}

      _.each(this.countryData, item => {
        data[item.id] = item.totals.count
      })

      window.$(this.$refs.mapChart).vectorMap({
        map: 'world_mill',
        backgroundColor: '#ffffff',
        regionStyle: {
          initial: {
            fill: '#e4e4e4'
          }
        },
        series: {
          regions: [{
            values: data,
            scale: ['#ff73a6', '#E12368'],
            normalizeFunction: 'polynomial'
          }]
        },
        onRegionTipShow: function (e, el, code) {
          el.html(el.html() + ' (' + (data[code] || 0) + ')')
        }
      })
    },
    legendClickCallback: function (event) {
      event = event || window.event

      let target = event.target || event.srcElement
      while (target.nodeName !== 'LI') {
        target = target.parentElement
      }
      let parent = target.parentElement
      let chartId = parseInt(parent.classList[0].split('-')[0], 10)
      let chart = Chart.instances[chartId]
      let index = Array.prototype.slice.call(parent.children).indexOf(target)

      chart.legend.options.onClick.call(chart, event, chart.legend.legendItems[index])
      if (chart.isDatasetVisible(index)) {
        target.classList.remove('hidden')
      } else {
        target.classList.add('hidden')
      }
    },
    renderStreamsChart: function () {
      if (!this.streamsData.data || !this.streamsData.data[0]) {
        return
      }

      let colors = [
        'rgba(85, 239, 196, 0.5)',
        'rgba(223, 230, 233, 0.5)',
        'rgba(162, 155, 254, 0.5)',
        'rgba(255, 234, 167, 0.5)',
        'rgba(250, 177, 160, 0.5)',
        'rgba(129, 236, 236, 0.5)'
      ]

      let endDate = moment()

      let labels = _.map(this.streamsData.data[0].totals, (item, index) => {
        if (index) {
          return endDate.subtract(1, 'days').format('MMM DD')
        } else {
          return endDate.format('MMM DD')
        }
      }).reverse()

      let datasets = _.map(this.streamsData.data, (item, index) => {
        return {
          label: item.name,
          backgroundColor: colors[index],
          data: item.totals,
          borderColor: colors[index],
          pointBackgroundColor: colors[index],
          legendColor: colors[index],
          fill: true,
          borderWidth: 2,
          pointRadius: 0
        }
      })

      let options = {
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        legendCallback: function (chart) {
          let text = []
          text.push('<ul class="' + chart.id + '-legend html-legend">')
          for (let i = 0; i < chart.data.datasets.length; i++) {
            text.push('<li><span style="background-color:' + chart.data.datasets[i].legendColor + '"></span>')
            if (chart.data.datasets[i].label) {
              text.push(chart.data.datasets[i].label)
            }
            text.push('</li>')
          }
          text.push('</ul>')
          return text.join('')
        }
      }

      if (this.streamGraphType === 'line') {
        options.plugins = {
          datalabels: {
            labels: {
              render: ''
            },
            formatter: function (value, context) {
              return value
            },
            backgroundColor: function (context) {
              return context.dataset.borderColor
            },
            borderRadius: 4,
            color: 'white'
          }
        }

        options.legend = {
          display: false
        }
      } else {
        options.plugins = {
          datalabels: {
            formatter: function (value, context) {
              return ''
            },
            backgroundColor: function (context) {
              return ''
            }
          }
        }
      }

      if (this.streamChart) {
        this.streamChart.clear()
        this.streamChart.destroy()
      }

      if (!this.$refs.streamsCanvas) {
        return
      }

      this.streamChart = new Chart(this.$refs.streamsCanvas.getContext('2d'), {
        type: this.streamGraphType,
        data: {
          labels: labels,
          datasets: datasets
        },
        options: options
      })

      if (this.streamGraphType === 'line') {
        let myLegendContainer = document.getElementById('streamsChartLegend')

        // generate HTML legend
        myLegendContainer.innerHTML = this.streamChart.generateLegend()

        // bind onClick event to all LI-tags of the legend
        let legendItems = myLegendContainer.getElementsByTagName('li')
        for (let i = 0; i < legendItems.length; i += 1) {
          legendItems[i].addEventListener('click', this.legendClickCallback, false)
        }
      }
    },
    getTrackStreams: function () {
      let from = ''

      if (!this.currentArtist || (!this.user.subscription || this.user.subscription.plan_name === 'indiefy_lite')) {
        this.loadingSongs = false
        return
      }

      if (this.timeRange === 'Weekly') {
        from = moment().subtract(9, 'days').format('YYYY-MM-DD')
      } else if (this.timeRange === 'Monthly') {
        from = moment().subtract(1, 'month').subtract(2, 'days').format('YYYY-MM-DD')
      } else if (this.timeRange === 'Yearly') {
        from = moment().subtract(1, 'year').subtract(2, 'days').format('YYYY-MM-DD')
      }

      this.loadingSongs = true

      return Analytics.getStreams({
        artist_id: this.currentArtist.f_id,
        data_type: 'list',
        type: 'asset',
        from,
        to: moment().subtract(2, 'days').format('YYYY-MM-DD')
      }).then(response => {
        this.songsData = response.data
        this.loadingSongs = false

        if (this.currentArtist.f_id) {
          this.showAIInsights = true
        }
      }).catch(() => {
        this.loadingSongs = false
      })
    },
    getStreamsData: function () {
      let from = ''

      if (!this.currentArtist) {
        this.loadingStreams = false
        return
      }

      if (this.timeRange === 'Weekly') {
        from = moment().subtract(9, 'days').format('YYYY-MM-DD')
      } else if (this.timeRange === 'Monthly') {
        from = moment().subtract(1, 'month').subtract(2, 'days').format('YYYY-MM-DD')
      } else if (this.timeRange === 'Yearly') {
        from = moment().subtract(1, 'year').subtract(2, 'days').format('YYYY-MM-DD')
      }

      this.loadingStreams = true

      return Analytics.getStreams({
        artist_id: this.currentArtist.f_id,
        data_type: 'chart',
        from,
        to: moment().subtract(2, 'days').format('YYYY-MM-DD')
      }).then(response => {
        if (response.data.groups) {
          response.data.groups = response.data.groups.slice(0, 5) // Exclude < 30s
        }

        if (response.data.data) {
          response.data.data = response.data.data.slice(0, 5)
        }

        this.streamsData = response.data
        this.loadingStreams = false

        if (this.currentArtist.f_id) {
          this.showAIInsights = true
        }

        setTimeout(() => {
          if (this.streamsData.data) {
            this.renderStreamsChart()
          }
        }, 1)
      }).catch((err) => {
        this.loadingStreams = false
        this.loadingData = false
        this.$notify({ message: this.$t('analytics_temporary_unavailable') }, 'warning', 'fa-exclamation')
        console.log('Error getting streams', err)
      })
    },
    getCountryData: async function () {
      let from = ''

      if (!this.isPro) {
        this.loadingCountries = false
        return
      }

      if (!this.currentArtist) {
        this.loadingCountries = false
        return
      }

      if (this.timeRange === 'Weekly') {
        from = moment().subtract(9, 'days').format('YYYY-MM-DD')
      } else if (this.timeRange === 'Monthly') {
        from = moment().subtract(1, 'month').subtract(2, 'days').format('YYYY-MM-DD')
      } else if (this.timeRange === 'Yearly') {
        if (!this.user.subscription) {
          this.timeRange = 'Weekly'
          return this.$eventBus.$emit('showUpgradeModal', '', 'analytics')
        }

        from = moment().subtract(1, 'year').subtract(2, 'days').format('YYYY-MM-DD')
      }

      this.loadingCountries = true

      await Analytics.getStreams({
        artist_id: this.currentArtist.f_id,
        data_type: 'list',
        type: 'territory',
        from,
        to: moment().subtract(2, 'days').format('YYYY-MM-DD')
      }).then(response => {
        this.loadingCountries = false
        this.countryData = response.data

        if (this.countryData.length) {
          setTimeout(() => {
            if (this.$refs.mapChart) {
              this.$refs.mapChart.innerHTML = ''
            }

            this.renderMapChart()
          }, 100)
        }
      })
    },
    setAnalyticType: function (type) {
      if (!this.isPro && type !== 'General') {
        setTimeout(() => {
          this.$eventBus.$emit('showUpgradeModal', '', 'analytics')
        }, 100)
      }

      this.analyticsType = type
    },
    setStreamGraphType: function (type) {
      this.streamGraphType = type

      if (this.streamChart.config.type !== type) {
        this.streamChart.config.type = type
        this.streamChart.update(this.streamChart.config)
      }
    },
    showTrackDetail: function (data, index) {
      this.topTrackData = data
      this.topTrackData.number = index + 1

      let rangeStreams = {}

      _.each(this.gaugeStreamData.Weekly.data, track => {
        if (track.id === this.topTrackData.id) {
          rangeStreams.weekly = track.totals
        }
      })

      _.each(this.gaugeStreamData.Monthly.data, track => {
        if (track.id === this.topTrackData.id) {
          rangeStreams.monthly = track.totals
        }
      })

      _.each(this.gaugeStreamData.Yearly.data, track => {
        if (track.id === this.topTrackData.id) {
          rangeStreams.yearly = track.totals
        }
      })

      this.topTrackData.streams = rangeStreams
      window.$(this.$refs.topTrackModal).modal('show')
    },
    getStreamsByRange: function (date) {
      return Analytics.getStreams({
        artist_id: this.currentArtist.f_id,
        data_type: 'list',
        type: 'asset',
        from: date,
        to: moment().subtract(2, 'days').format('YYYY-MM-DD')
      })
    },
    getAllPlays: function (params) {
      return Analytics.getAllPlays(params)
    },
    renderPlaysChart: function (data) {
      let options = {
        legend: {
          display: data.showLegend
        },
        plugins: {
          responsive: true,
          datalabels: {
            formatter: function (value, context) {
              return value
            }
          },
          legendCallback: (chart) => {
            return this.legendCallback(chart)
          }
        },
        layout: {
          padding: 25
        }
      }

      if (data.type === 'bar') {
        options.scales = {
          xAxes: [{
            gridLines: {
              color: 'rgba(0, 0, 0, 0)'
            }
          }],
          yAxes: [{
            gridLines: {
              color: 'rgba(0, 0, 0, 0)'
            },
            ticks: {
              display: false
            }
          }]
        }

        options.plugins.datalabels = {
          color: '#000',
          anchor: 'end',
          align: 'start',
          offset: -20,
          font: {
            weight: 'bold',
            size: '10'
          }
        }
      } else if (data.type === 'pie') {
        options.plugins.datalabels = {
          borderRadius: 25,
          color: '#fff',
          anchor: 'end',
          align: 'start',
          offset: -10,
          borderWidth: 2,
          borderColor: '#fff',
          backgroundColor: (context) => {
            return context.dataset.backgroundColor
          },
          font: {
            weight: 'bold',
            size: '10'
          },
          formatter: (value, ctx) => {
            let sum = 0
            let dataArr = ctx.chart.data.datasets[0].data
            dataArr.map(data => {
              sum += data
            })
            let percentage = (((value * 100 / sum)) ? (value * 100 / sum).toFixed(2) : 0) + '%'
            return percentage
          }
        }
      }

      if (this[data.canvasId]) {
        this[data.canvasId].clear()
        this[data.canvasId].destroy()
      }

      this[data.canvasId] = new Chart(data.canvas, {
        type: data.type,
        data: {
          labels: data.labels,
          datasets: [
            {
              backgroundColor: data.colors,
              data: data.data
            }
          ]
        },
        options: options
      })

      let myLegendContainer = document.getElementById('playDurationLabels')
      myLegendContainer.innerHTML = this[data.canvasId].generateLegend()

      // bind onClick event to all LI-tags of the legend
      let legendItems = myLegendContainer.getElementsByTagName('li')
      for (let i = 0; i < legendItems.length; i += 1) {
        legendItems[i].addEventListener('click', this.legendClickCallback, false)
      }
    },
    getSpotifyInsightsData: async function () {
      let from = this.gaugeStreamData[this.selectedGauge].date
      let to = moment().subtract(2, 'days').format('YYYY-MM-DD')

      let params = {
        artist_id: this.currentArtist.f_id,
        dsp: 'spotify',
        from: from,
        to: to,
        playsBy: 'duration'
      }

      await this.getAllPlays(params).then((response) => {
        if (response.data && this.$refs.playDurationCanvas) {
          let playDurationText = {
            '0-30': '0s < 30s',
            '30-60': '> 30s - 60s',
            '>60': '> 60s (not full)',
            'full': 'FULL'
          }

          let datasetData = _.map(response.data, (data, index) => {
            return data
          })

          let labels = _.map(response.data, (data, index) => {
            return playDurationText[index]
          })

          let params = {
            labels: labels,
            data: datasetData,
            canvasId: 'playDurationCanvas',
            canvasLabels: 'playDurationLabels',
            canvas: this.$refs.playDurationCanvas.getContext('2d'),
            type: 'pie',
            showLegend: true,
            colors: ['#ff5245', '#ffb845', '#45d4ff', '#35de65']
          }

          this.renderPlaysChart(params)

          // let paramsDetail = {
          //   labels: labels,
          //   data: datasetData,
          //   canvasId: 'playDurationDetailCanvas',
          //   canvasLabels: 'playDurationDetailLabels',
          //   canvas: this.$refs.playDurationDetailCanvas.getContext('2d'),
          //   type: 'doughnut',
          //   showLegend: false,

          //   colors: ['#ff5245', '#ffb845', '#45d4ff', '#35de65']
          // }

          // this.renderPlaysChart(paramsDetail)
        }
      })

      params.playsBy = 'gender'

      await this.getAllPlays(params).then((response) => {
        if (response.data && this.$refs.genderCanvas) {
          let labels = _.map(response.data, (values, index) => {
            return values.gender
          })

          let datasetData = _.map(response.data, (values, index) => {
            return values.plays
          })

          let params = {
            labels: labels,
            data: datasetData,
            canvasId: 'genderCanvas',
            canvasLabels: 'genderLabels',
            canvas: this.$refs.genderCanvas.getContext('2d'),
            type: 'pie',
            showLegend: true,
            colors: ['#ff5245', '#ffb845', '#45d4ff', '#35de65']
          }

          this.renderPlaysChart(params)
        }
      })

      params.playsBy = 'device'

      await this.getAllPlays(params).then((response) => {
        if (response.data && this.$refs.deviceCanvas) {
          let labels = _.map(response.data, (values, index) => {
            return values.device_type
          })

          let datasetData = _.map(response.data, (values, index) => {
            return values.plays
          })

          let params = {
            labels: labels,
            data: datasetData,
            canvasId: 'deviceCanvas',
            canvasLabels: 'deviceLabels',
            canvas: this.$refs.deviceCanvas.getContext('2d'),
            type: 'bar',
            showLegend: false,
            colors: ['#ff5245', '#ffb845', '#45d4ff', '#35de65', 'green', 'blue', 'yellow']
          }

          this.renderPlaysChart(params)
        }
      })

      params.playsBy = 'age'

      await this.getAllPlays(params).then((response) => {
        let groups = {
          unknown: 0,
          one: 0,
          two: 0,
          three: 0,
          four: 0,
          five: 0,
          six: 0,
          seven: 0
        }

        if (response && this.$refs.ageCanvas) {
          _.each(response.data, (data) => {
            switch (true) {
              case (data.age === null):
                groups.unknown += data.plays
                break
              case (data.age <= 17):
                groups.one += data.plays
                break
              case (data.age >= 18 && data.age <= 22):
                groups.two += data.plays
                break
              case (data.age >= 23 && data.age <= 27):
                groups.three += data.plays
                break
              case (data.age >= 28 && data.age <= 34):
                groups.four += data.plays
                break
              case (data.age >= 35 && data.age <= 44):
                groups.five += data.plays
                break
              case (data.age >= 45 && data.age <= 59):
                groups.six += data.plays
                break
              case (data.age >= 60):
                groups.seven += data.plays
                break

              default:
                break
            }
          })

          let datasetData = _.map(groups, (values, index) => {
            return values
          })

          let params = {
            labels: ['unknown', '0-17', '18-22', '23-27', '28-34', '35-44', '45-59', '60+'],
            data: datasetData,
            canvasId: 'ageCanvas',
            canvasLabels: 'ageLabels',
            canvas: this.$refs.ageCanvas.getContext('2d'),
            type: 'bar',
            showLegend: false,
            colors: ['#ff5245', '#ffb845', '#45d4ff', '#35de65', 'green', 'blue', 'yellow']
          }

          this.renderPlaysChart(params)
        }
      })
    },
    legendCallback: (chart) => {
      let text = []
      text.push(`<ul class="${chart.id}-legend html-legend">`)
      for (let i = 0; i < chart.data.datasets.length; i++) {
        text.push('<li><span style="background-color:' + chart.data.datasets[i].legendColor + '"></span>')
        if (chart.data.datasets[i].label) {
          text.push(chart.data.datasets[i].label)
        }
        text.push('</li>')
      }

      text.push('</ul>')
      return text.join('')
    }
  },
  created: function () {
    this.user = this.$user

    if (this.user.subscription && this.user.subscription.plan_name !== 'indiefy_lite') {
      this.isPro = true
    }

    let explanationMonth = window.localStorage.getItem('analytics_explanation_date')

    if (explanationMonth !== moment().month().toString()) {
      this.showAnalyticsExplanation = true
      window.localStorage.setItem('analytics_explanation_date', moment().month())
    }

    Artists.setFugaArtists().then(() => {
      Artists.getAll().then(response => {
        this.artists = _.map(response.data, item => {
          return {
            id: item._id,
            text: item.name,
            f_id: item.f_id,
            image: item.cover_image_small || item.cover_image,
            createdAt: moment(item.createdAt).format('YYYY-MM-DD')
          }
        })

        this.artistsLoaded = true

        if (!this.artists.length) {
          this.loadingStreams = false
          return
        }

        setTimeout(() => {
          if (window.localStorage.getItem('defaultArtist') && _.find(this.artists, artist => window.localStorage.getItem('defaultArtist') === artist.id)) {
            this.currentArtist = _.find(this.artists, artist => window.localStorage.getItem('defaultArtist') === artist.id)
            this.artistId = this.currentArtist.id
          } else if (this.artists[0]) {
            this.currentArtist = this.artists[0]
            this.artistId = this.artists[0].id
          }

          if (window.innerWidth < 768) {
            this.device = 'mobile'
          }
        }, 1)

        // if (!this.user.subscription) {
        //   setTimeout(() => {
        //     (window.adsbygoogle = window.adsbygoogle || []).push({})

        //     setTimeout(() => {
        //       (window.adsbygoogle = window.adsbygoogle || []).push({})

        //       setTimeout(() => {
        //         (window.adsbygoogle = window.adsbygoogle || []).push({})
        //       }, 100)
        //     }, 100)
        //   }, 3000)
        // }
      })
    })
  },
  watch: {
    artistId: async function (value) {
      if (value) {
        this.currentArtist = _.find(this.artists, artist => artist.id === value)
        window.localStorage.setItem('defaultArtist', this.currentArtist.id)

        await this.getStreamsData()
        await this.getTrackStreams()
        await this.getCountryData()
        await this.getArtistDistributions()

        this.pageLoaded = true
      }
    },
    timeRange: async function (value) {
      if (value) {
        this.selectedGauge = value

        if (value === 'Yearly' && !this.user.subscription) {
          setTimeout(() => {
            this.timeRange = 'Weekly'
          }, 1)

          return this.$eventBus.$emit('showUpgradeModal', '', 'analytics')
        }

        await this.getStreamsData()
        await this.getTrackStreams()
        await this.getCountryData()
        await this.getArtistDistributions()

        this.pageLoaded = true
        // this.getSpotifyInsightsData()
      }
    }
  },
  mounted: function () {
  },
  components: {
    Select2,
    PlaylistsCard,
    UpgradeOverlay,
    UpgradeModal,
    UpgradeBanner
  }
}
</script>
<style lang="scss" scoped>
@media screen and (max-width:576px) {
  .indiebot {
    width: 100px !important;
  }

  .bot-container {
    text-align: center !important;
  }

  .talk-bubble {
    margin: 0 !important;
    width: 100% !important;
  }
}

.bot-container {
  text-align: right;
}

.indiebot {
  width: 90%;
}
.v-map {
  width: 100%;
  height: 400px;
}

.chart-container {
  min-height: 350px;
}

.streams-gauge {
  zoom: 0.7
}

.text-50 {
  font-size: 50px;
}

.analytics-type {
  height: 40px;
}

.streams-table {
  min-height: 200px;
}

.tri-right.left-top:after{
  content: ' ';
  position: absolute;
  width: 0;
  height: 0;
  left: -20px;
  right: auto;
  top: 0px;
  bottom: auto;
  border: 22px solid;
  border-color: #f8f9fa transparent transparent transparent;
}

.talk-bubble {
  margin: 40px;
  display: inline-block;
  position: relative;
  width: 95%;
  height: auto;
  background-color: #f8f9fa;
}

.talktext {
  color: #444444;
  padding: 1em 1.5em;
  text-align: left;
  line-height: 1.5em;
}
.talktext p, .talktext div {
  font-size: 16px;
  /* remove webkit p margins */
  -webkit-margin-before: 0em;
  -webkit-margin-after: 0em;
}

.badge-date {
  position: absolute;
  top: -7px;
  right: -6px;
}
</style>



// WEBPACK FOOTER //
// src/components/Analytics.vue